import React, { memo } from 'react';
import Box from '@material-ui/core/Box';
import Avatar from '@material-ui/core/Avatar';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { getTickerLogo } from '../WatchlistHelpers';

const useStyles = makeStyles(theme => ({
  tickerLogo: {
    display: 'flex',
    height: 40,
    alignItems: 'center',
  },
  logo: {
    height: 20,
    width: 20,
    '& .MuiAvatar-img': {
      objectFit: 'contain',
    },
    '&.MuiAvatar-colorDefault': {
      visibility: 'hidden',
    },
    '&.MuiAvatar-root': {
      borderRadius: 1,
    },
  },
  tickerText: {
    textAlign: 'left',
    marginLeft: 10,
  },
}));

const TickerLogo = ({ value, data }) => {
  const classes = useStyles();
  const tickerValue = value.includes('-G') ? '' : value;

  return (
    <Box className={classes.tickerLogo}>
      <Avatar alt="-" src={getTickerLogo(data)} className={classes.logo} />
      <Box variant="outlined" className={classes.tickerText}>
        {tickerValue}
      </Box>
    </Box>
  );
};

export default memo(TickerLogo);
